import React from 'react'
import { Clipboard } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import Color from 'color'
import { Button, Container } from '../atoms'
import { MESSAGE_TYPE, useMessage } from '../../utils/helpers/MessageProvider'

export const CopyText = ({
  text = 'https://myshareurl.com/23423423432423432',
  copyMessage = 'Link Copied',
  textTransform,
  color,
  ...props
}) => {
  const {
    colors: { tertiaryDark, primary, accentText, surface },
  } = useTheme()
  const { setMessage } = useMessage()

  return (
    <Container
      row
      style={{
        borderColor: tertiaryDark,
        borderWidth: 1,
        borderRadius: 8,
        height: 54,
        overflow: 'hidden',
        flex: 1,
        margin: 10,
        width: 489,
        height: 54,
        maxHeight: 54,
      }}
    >
      <Text
        numberOfLines={1}
        ellipsizeMode="head"
        style={{
          color: color || Color(primary).alpha(0.2).rgb().string(),
          paddingHorizontal: 18,
          marginVertical: 'auto',
          fontSize: 18,
          paddingRight: 40,
          flex: 1,
        }}
      >
        {text}
      </Text>
      <Button
        onPress={() => {
          Clipboard.setString(text)
          setMessage(MESSAGE_TYPE.SUCCESS, copyMessage)
        }}
        style={{
          backgroundColor: '#007FCF',
          flex: 1,
          minWidth: 120,
          maxWidth: 147,
          width: 147,
          justifyContent: 'center',
          height: 54,
        }}
        labelStyle={{
          color: surface,
          textTransform: textTransform || 'uppercase',
        }}
      >
        Copy
      </Button>
    </Container>
  )
}
